(function () {
  "use strict";

  angular
    .module("admin.coupons.service", [])
    .factory("CouponsService", CouponsService);

  /** @ngInject */
  function CouponsService($http, $q, API) {
    function getByIds(ids) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/coupons/ids?ids=" + ids)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function list(start, limit) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/coupons?start=" + start + "&limit=" + limit)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listUnpublished(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/coupons/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listPublished(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/coupons/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listArchived(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/coupons/archived?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/coupons/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/coupons", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/coupons/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/coupons/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/coupons/" + id + "/publish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/coupons/" + id + "/unpublish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function archive(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/coupons/" + id + "/archive")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      getByIds: getByIds,
      listUnpublished: listUnpublished,
      listPublished: listPublished,
      listArchived: listArchived,
      list: list,
      get: get,
      save: save,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      archive: archive,
    };
  }
})();
